/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'

/**
 * Assembles the file name for an order when downloaded as a pdf
 *
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<string>}
 */
const getOrderName = async (module, component, event) => {
  const { [G.INTL]: intl } = module[G.ADAPTER]

  const { value: { submitTimestamp } } = module[G.MODEL][G.CACHE] || {}
  const date = intl.getLocaleDate(submitTimestamp, { dateStyle: 'short' })
  const fileDate = date.replaceAll('.', '') // 01.01.25 => 010125

  const label = await intl.translate('label.purchaseRequest', {
    ns: 'cart',
    _key: 'label.purchaseReqesut',
    defaultValue: 'Purchase Request',
  })

  return `${label}-${fileDate}`
}

export default curry(getOrderName)
